export class ColaPepIntento {
    model = {
        id: { value: null, export: false, header: 'Código' },
        inicio: { value: new Date(), export: true, header: 'Fecha carga existosa:', required: 'Fecha es requerido', table: true, sort: true, filterField: 'fecha' },
        estado_nombre: { value: null, export: true, header: 'Estado', required: false, table: true, sort: false },
    }
}
